import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fileUrl } from "@/lib/api";

export default function Cart() {
  const { t, fmt, cart, user, lang } = useApp();
  const nav = useNavigate();
  const loginNeeded = !user && cart.items.some((i) => i.type !== "physical");
  if (!cart.items.length) return (
    <div className="max-w-2xl mx-auto py-32 text-center space-y-6" data-testid="cart-empty">
      <h1 className="font-serif text-4xl">{t("cart")}</h1>
      <p className="text-[#6E6259]">{t("empty_cart")}</p>
      <Link to="/shop" className="inline-block bg-[#3B220C] text-white px-8 py-3 text-sm">{t("continue")}</Link>
    </div>
  );
  return (
    <div className="max-w-[1200px] mx-auto px-4 sm:px-8 py-12 grid lg:grid-cols-3 gap-12" data-testid="cart-page">
      <div className="lg:col-span-2">
        <h1 className="font-serif text-4xl sm:text-5xl mb-8">{t("cart")}</h1>
        <div className="divide-y divide-[#E6DFD5] border-y border-[#E6DFD5]">
          {cart.items.map((i) => (
            <div key={i.key} className="py-6 flex gap-5" data-testid={`cart-item-${i.slug}`}>
              <img src={fileUrl(i.image)} alt="" className="w-24 h-28 object-cover bg-[#F6F2EE]" />
              <div className="flex-1 space-y-1">
                <div className="flex justify-between gap-4">
                  <Link to={`/product/${i.slug}`} className="font-serif text-xl hover:text-[#8C4F27]">{i.name}</Link>
                  <button onClick={() => cart.remove(i.key)} data-testid={`cart-remove-${i.slug}`} aria-label="Remove"><X size={16} /></button>
                </div>
                <p className="font-mono text-[10px] tracking-[0.15em] text-[#8C4F27]">{t(i.type).toUpperCase()}</p>
                {Object.entries(i.variant || {}).map(([k, v]) => <p key={k} className="text-xs text-[#6E6259]">{k}: {v}</p>)}
                {i.session_start && <p className="text-xs text-[#6E6259]">{new Date(i.session_start).toLocaleString(lang === "id" ? "id-ID" : "en-GB")}</p>}
                <div className="flex items-center justify-between pt-2">
                  {["physical", "workshop"].includes(i.type) ? (
                    <div className="flex items-center border border-[#E6DFD5]">
                      <button className="p-2" onClick={() => cart.setQty(i.key, i.qty - 1)} data-testid={`cart-dec-${i.slug}`}><Minus size={12} /></button>
                      <span className="w-8 text-center text-sm">{i.qty}</span>
                      <button className="p-2" onClick={() => cart.setQty(i.key, i.qty + 1)} data-testid={`cart-inc-${i.slug}`}><Plus size={12} /></button>
                    </div>
                  ) : <span />}
                  <span>{fmt(i.price * i.qty)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <aside className="bg-white border border-[#E6DFD5] p-8 h-fit space-y-5 lg:sticky lg:top-32">
        <div className="flex justify-between"><span>{t("subtotal")}</span><span data-testid="cart-subtotal">{fmt(cart.subtotal)}</span></div>
        <p className="text-xs text-[#6E6259]">{t("shipping")} & {t("discount").toLowerCase()} → {t("checkout").toLowerCase()}</p>
        {loginNeeded && <p className="text-xs text-[#9E2A2B]" data-testid="cart-login-note">{t("login_required")}: patterns / courses / workshops.</p>}
        <button onClick={() => nav("/checkout")} data-testid="cart-checkout-btn" className="w-full bg-[#3B220C] text-white py-4 text-sm tracking-wider hover:bg-[#4A2C11] transition-colors">{t("checkout")}</button>
      </aside>
    </div>
  );
}
